import React from 'react';
import { useSession } from '@/hooks/useSession';
import tiaBoasVindas from '@/assets/images/tia/TIA-BOAS-VINDAS.png';
import { TypewriterText } from '@/components/custom/typewriter-text';

// Mensagem de incentivo por dia da semana (0=domingo … 6=sábado).
const WEEKDAY_MESSAGES = [
  'Domingo é dia de recarregar — que tal um aquecimento pro SAEB? 🌤️',
  'Bora começar a semana com tudo rumo ao SAEB! 💪',
  'Terça de foco: mais um passo rumo ao SAEB? 🚀',
  'Já é quarta! Mantém o ritmo na trilha SAEB. 🔥',
  'Quinta voando! Avança mais um bloco da trilha. ⚡',
  'Sextou! Que tal fechar a semana evoluindo no SAEB? 🎉',
  'Sábado também conta — um pouquinho de SAEB hoje? 😎'
];

// Saudação completa da T.I.A: nome + incentivo do dia.
export function greetingForDay(day, firstName) {
  const hi = firstName ? `Oi, ${firstName}! 👋` : 'Oi! 👋';
  return `${hi} ${WEEKDAY_MESSAGES[day] ?? WEEKDAY_MESSAGES[1]}`;
}

// Trilha pontilhada decorativa (SVG inline, aria-hidden).
export function DottedTrail() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className="pointer-events-none absolute right-0 top-0 h-full w-28 opacity-60"
      viewBox="0 0 112 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        d="M 8 70 Q 40 50 60 30 Q 78 12 100 8"
        stroke="var(--color-secondary-light)"
        strokeWidth="2"
        strokeDasharray="5 5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

// Boas-vindas lúdicas da Versão B: a T.I.A (mesma mascote da trilha) recebe o
// aluno pelo primeiro nome, com incentivo que varia por dia da semana.
export function HeroWelcome({ message: messageOverride } = {}) {
  const { session } = useSession();
  const firstName = (session?.user?.name || '').trim().split(' ')[0];
  const message = messageOverride ?? greetingForDay(new Date().getDay(), firstName);

  return (
    <div className="relative flex h-full items-center gap-3 rounded-[24px] bg-[var(--color-bg-lilac)] p-4 pl-[200px] shadow-card">
      {/* Trilha pontilhada decorativa */}
      <DottedTrail />

      {/* T.I.A recortada (PNG transparente) — maior que o card e ancorada no rodapé,
          então a cabeça/topo estoura pra fora da moldura. */}
      <img
        src={tiaBoasVindas}
        alt="T.I.A"
        className="pointer-events-none absolute bottom-0 left-2 z-10 h-[215px] w-auto object-contain object-bottom"
      />

      {/* Balão de fala */}
      <div className="relative z-10 max-w-sm rounded-[16px] rounded-tl-none bg-white p-3.5 shadow-card">
        <p
          className="mb-0 text-sm font-bold leading-relaxed"
          style={{ color: '#222731' }}
        >
          <TypewriterText text={message} />
        </p>
      </div>

      {/* Decorações emoji absolutas */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-5 top-2 text-xl"
      >
        ⭐
      </span>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute right-12 top-6 text-lg"
        style={{ transform: 'rotate(-20deg)' }}
      >
        ✈️
      </span>
    </div>
  );
}
